import s from './WeekdaySelector.module.scss';

interface WeekdaySelectorProps {
  selectedDays: number[]; // Array of selected day indices (0 for Sunday, 1 for Monday, ..., 6 for Saturday)
  onDayToggle: (dayIndex: number) => void; // Function to toggle the selection of a day
}

export const WeekdaySelector = ({ selectedDays, onDayToggle }: WeekdaySelectorProps) => {
  return (
    <div className={s.daysContainer}>
      <button
        className={selectedDays?.includes(0) ? s.selected : ''}
        type="button"
        onClick={(e) => {
          onDayToggle(0);
          e.currentTarget.blur();
        }}
      >
        Su
      </button>
      <button
        className={selectedDays?.includes(1) ? s.selected : ''}
        type="button"
        onClick={(e) => {
          onDayToggle(1);
          e.currentTarget.blur();
        }}
      >
        Mo
      </button>
      <button
        className={selectedDays?.includes(2) ? s.selected : ''}
        type="button"
        onClick={(e) => {
          onDayToggle(2);
          e.currentTarget.blur();
        }}
      >
        Tu
      </button>
      <button
        className={selectedDays?.includes(3) ? s.selected : ''}
        type="button"
        onClick={(e) => {
          onDayToggle(3);
          e.currentTarget.blur();
        }}
      >
        We
      </button>
      <button
        className={selectedDays?.includes(4) ? s.selected : ''}
        type="button"
        onClick={(e) => {
          onDayToggle(4);
          e.currentTarget.blur();
        }}
      >
        Th
      </button>
      <button
        className={selectedDays?.includes(5) ? s.selected : ''}
        type="button"
        onClick={(e) => {
          onDayToggle(5);
          e.currentTarget.blur();
        }}
      >
        Fr
      </button>
      <button
        className={selectedDays?.includes(6) ? s.selected : ''}
        type="button"
        onClick={(e) => {
          onDayToggle(6);
          e.currentTarget.blur();
        }}
      >
        Sa
      </button>
    </div>
  );
};
